import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { User } from '../../_models/user';
import { Router } from '@angular/router';
import { ApiIntegration } from '../../_services/api.integration';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-login-popup',
  templateUrl: './login-popup.component.html',
  styleUrls: ['./login-popup.component.css'],
})
export class LoginPopupComponent implements OnInit {
  uploadMou: string;
  imageUrl: string;
  state: string;
  statesList = [];
  citiesList = [];
  imagepanCard: string;
  imageAadhar: string;
  errorMessage: string;
  statusText: string = "";
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";
  statusText11: string = "";
  statusText12: string = "";
  statusText13: string = "";
  statusText14: string = "";
  warehouse: any;
  panNoerrorMessage: any;
  panCard: any;
  panCardPhoto: string;
  idCard: any;
  idCardPhoto: string;
  aadhar: any;
  aadharPhoto: string;
  gstNo: any;
  address1: any;
  address2: any;
  city: any;
  zipCode: any;
  geoCode: any;
  allPopup: string = 'N';
  kycPopup: boolean = false;
  mouPopup: boolean = false;
  addressPopup: boolean = false;
  channelPopup: boolean = false;
  shippingPopup: boolean = false;
  warehouseError: string = '';

  constructor(public g: Globals, private api: ApiIntegration, private alertService: AlertService, public activeModal: NgbActiveModal, private http: HttpClient, public user: User, private router: Router) {

    /* this.stateList = [
      {label: 'Telangana', config: 'Telangana'},
      {label: 'AndhraPradesh', config: 'AndhraPradesh'},
      {label: 'Maharashtra', config: 'Maharshtra'},
      {label: 'Karnataka', config: 'Karnataka'},
      {label: 'TamilNadu', config: 'TamilNadu'},


    ]; */


    this.stateList();
    this.cityList();

    if (g.profilePopupDisplay == 0) {
      if (!g.profilePopup.isMOUDocPresent) {
        this.mouPopup = true;
      } else if (!g.profilePopup.isKYCVerified) {
        this.kycPopup = true;
      } else if (!g.profilePopup.isDefaultAddressPresent) {
        this.addressPopup = true;
      } else if (!g.profilePopup.isChannelPresent) {
        this.channelPopup = true;
      }
    }
  }

  ngOnInit() {
  }

  uploadMouDoc() {
    this.statusText = "";
    if (this.uploadMou == '' || this.uploadMou === null || this.uploadMou === undefined || this.uploadMou === 'undefined') {
      this.statusText = 'Please Upload Mou';
      return false;
    }
    this.g.loaderDisplay = "display";
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadMOUDocuments', {
      "accountOwnerId": this.user.accountOwnerId,
      "mouDocument": this.imageUrl,
      "organizationId": 1
    }, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Mou Document', 'Uploaded Successfully');
        if (!this.g.profilePopup.isKYCVerified) {
          this.kycPopup = true;
          this.mouPopup = false;
          this.addressPopup = false;
          this.channelPopup = false;
          this.shippingPopup = false;
        } else if (!this.g.profilePopup.isDefaultAddressPresent) {
          this.addressPopup = true;
          this.mouPopup = false;
          this.kycPopup = false;
          this.channelPopup = false;
          this.shippingPopup = false;
        } else if (!this.g.profilePopup.isChannelPresent) {
          this.channelPopup = true;
          this.mouPopup = false;
          this.kycPopup = false;
          this.addressPopup = false;
          this.shippingPopup = false;
        } else if (this.g.profilePopup.isKYCVerified && this.g.profilePopup.isChannelPresent && this.g.profilePopup.isDefaultAddressPresent) {
          this.activeModal.dismiss();
        }
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }

  skipPopup() {
    if (!this.g.profilePopup.isKYCVerified) {
      this.kycPopup = true;
      this.mouPopup = false;
      this.addressPopup = false;
      this.channelPopup = false;
      this.shippingPopup = false;
    } else if (!this.g.profilePopup.isDefaultAddressPresent) {
      this.addressPopup = true;
      this.mouPopup = false;
      this.kycPopup = false;
      this.channelPopup = false;
      this.shippingPopup = false;
    } else if (!this.g.profilePopup.isChannelPresent) {
      this.channelPopup = true;
      this.mouPopup = false;
      this.kycPopup = false;
      this.addressPopup = false;
      this.shippingPopup = false;
    } else if (this.g.profilePopup.isKYCVerified && this.g.profilePopup.isChannelPresent && this.g.profilePopup.isDefaultAddressPresent) {
      this.activeModal.dismiss();
      this.g.profilePopupDisplay = 1;
    }
  }

  skipPopup1() {
    if (!this.g.profilePopup.isDefaultAddressPresent) {
      this.addressPopup = true;
      this.mouPopup = false;
      this.kycPopup = false;
      this.channelPopup = false;
      this.shippingPopup = false;
    } else if (!this.g.profilePopup.isChannelPresent) {
      this.channelPopup = true;
      this.mouPopup = false;
      this.kycPopup = false;
      this.addressPopup = false;
      this.shippingPopup = false;
    } else if (this.g.profilePopup.isChannelPresent && this.g.profilePopup.isDefaultAddressPresent) {
      this.activeModal.dismiss();
      this.g.profilePopupDisplay = 1;
    }
  }

  kycVerfication() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    if (this.panCard == '' || this.panCard === null || this.panCard === undefined || this.panCard === 'undefined') {
      this.statusText1 = 'Please enter Mandatory fields';
    }
    if (this.panCardPhoto == '' || this.panCardPhoto === null || this.panCardPhoto === undefined || this.panCardPhoto === 'undefined') {
      this.statusText2 = 'Please Upload Pancard';
    }
    if (this.aadhar == '' || this.aadhar === null || this.aadhar === undefined || this.aadhar === 'undefined') {
      this.statusText5 = 'Please enter Aadhar number';
    }
    if (this.aadharPhoto == '' || this.aadharPhoto === null || this.aadharPhoto === undefined || this.aadharPhoto === 'undefined') {
      this.statusText6 = 'Please Upload Aadhar Card';
    }
    if (this.statusText1 !== "" || this.statusText2 !== "" || this.statusText5 !== "" || this.statusText6 !== "") {
      return false;
      this.statusText13 = 'Please enter Mandatory fields';
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadKYCDocuments', {
      "aadharCardImage": this.imageAadhar,
      "aadharCardNumber": this.aadhar,
      "accountOwnerId": this.user.accountOwnerId,
      "gstNumber": this.gstNo,
      "organizationId": 1,
      "panCardImage": this.imagepanCard,
      "panCardNumber": this.panCard
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success('Kyc', 'Updated Successfully');
          if (!this.g.profilePopup.isDefaultAddressPresent) {
            this.addressPopup = true;
            this.mouPopup = false;
            this.kycPopup = false;
            this.channelPopup = false;
            this.shippingPopup = false;
          } else if (!this.g.profilePopup.isChannelPresent) {
            this.channelPopup = true;
            this.mouPopup = false;
            this.kycPopup = false;
            this.addressPopup = false;
            this.shippingPopup = false;
          } else if (this.g.profilePopup.isChannelPresent && this.g.profilePopup.isDefaultAddressPresent) {
            this.activeModal.dismiss();
          }
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });

  }

  skipPopUp() {
    this.activeModal.dismiss();
    this.g.profilePopupDisplay = 1;
  }

  resetPopUp() {
    if (this.kycPopup) {
      if (!this.g.profilePopup.isMOUDocPresent) {
        this.mouPopup = true;
        this.kycPopup = false;
        this.addressPopup = false;
        this.channelPopup = false;
      } else if (!this.g.profilePopup.isMOUDocPresent) {
        this.mouPopup = true;
        this.kycPopup = false;
        this.addressPopup = false;
        this.channelPopup = false;
      }
    } else if (this.addressPopup) {
      if (!this.g.profilePopup.isKYCVerified) {
        this.kycPopup = true;
        this.mouPopup = false;
        this.addressPopup = false;
        this.channelPopup = false;
      } else if (!this.g.profilePopup.isMOUDocPresent) {
        this.mouPopup = true;
        this.kycPopup = false;
        this.addressPopup = false;
        this.channelPopup = false;
      }
    } else if (this.channelPopup) {
      if (!this.g.profilePopup.isDefaultAddressPresent) {
        this.addressPopup = true;
        this.mouPopup = false;
        this.kycPopup = false;
        this.channelPopup = false;
      } else if (!this.g.profilePopup.isKYCVerified) {
        this.kycPopup = true;
        this.mouPopup = false;
        this.addressPopup = false;
        this.channelPopup = false;
      } else if (!this.g.profilePopup.isMOUDocPresent) {
        this.mouPopup = true;
        this.kycPopup = false;
        this.addressPopup = false;
        this.channelPopup = false;
      }
    }

  }

  closePopup() {
    this.activeModal.dismiss();
    this.router.navigate(['/admin/storeConnections/']);
  }

  createAddress() {
    this.g.loaderDisplay = "display";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";

    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText8 = 'Please enter address';
    }

    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText9 = 'Please enter city';
    }
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText10 = 'Please enter state';
    }
    if (this.zipCode == '' || this.zipCode === null || this.zipCode === undefined || this.zipCode === 'undefined') {
      this.statusText11 = 'Please enter zip';
    } else if (this.zipCode.length != 6) {
      this.statusText11 = 'ZipCode must be minimum 6 characters';
    }
    if (this.statusText8 != "" || this.statusText9 != "" || this.statusText10 != "" || this.statusText11 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAddress', {
      "accountOwnerId": this.user.accountOwnerId,
      "address1": this.address1,
      "address2": this.address2,
      "addressType": "BILLING",
      "city": this.city,
      "organizationId": 1,
      "state": this.state,
      "status": "ACTIVE",
      "zip": this.zipCode,
      "geoCode": this.geoCode
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Address', 'Created Successfully');
          if (!this.g.profilePopup.isChannelPresent) {
            this.channelPopup = true;
            this.mouPopup = false;
            this.kycPopup = false;
            this.addressPopup = false;
            this.shippingPopup = false;
          } else if (this.g.profilePopup.isChannelPresent) {
            this.activeModal.dismiss();
          }
        } else if (data['code'] == 400) {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  createShipAddress() {
    this.g.loaderDisplay = "display";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";

    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText8 = 'Please enter Mandatory fields';
    }

    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText9 = 'Please enter city';
    }
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText10 = 'Please enter state';
    }
    if (this.zipCode == '' || this.zipCode === null || this.zipCode === undefined || this.zipCode === 'undefined') {
      this.statusText11 = 'Please enter zip';
    } else if (this.zipCode.length != 6) {
      this.statusText11 = 'ZipCode must be minimum 6 characters';
    }
    if (this.statusText8 != "" || this.statusText9 != "" || this.statusText10 != "" || this.statusText11 != "") {
      this.g.loaderDisplay = "";
      return false;
      this.statusText14 = 'Please enter Mandatory fields';
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAddress', {
      "accountOwnerId": this.user.accountOwnerId,
      "address1": this.address1,
      "address2": this.address2,
      "addressType": "SHIPPING",
      "city": this.city,
      "organizationId": 1,
      "state": this.state,
      "status": "ACTIVE",
      "zip": this.zipCode,
      "geoCode": this.geoCode
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Address', 'Created Successfully');
        } else if (data['code'] == 400) {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  defaultWarehouse() {
    if (!this.warehouse || !(this.warehouse || {}).warehouseId) {
      this.warehouseError = "Please select warehouse";
      return
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/MakeApprovedWarehouseDefault', {
      "accountOwnerId": this.user.accountOwnerId,
      "warehouseId": (this.warehouse || {}).warehouseId,
      "warehouseReqId": (this.warehouse || {}).warehouseReqId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Warehouse', data['message']);

        } else if (data['code'] == 400) {
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
    if (!this.g.profilePopup.isKYCVerified) {
      this.kycPopup = true;
      this.mouPopup = false;
      this.addressPopup = false;
      this.channelPopup = false;
      this.shippingPopup = false;
    } else if (!this.g.profilePopup.isDefaultAddressPresent) {
      this.addressPopup = true;
      this.mouPopup = false;
      this.kycPopup = false;
      this.channelPopup = false;
      this.shippingPopup = false;
    } else if (!this.g.profilePopup.isChannelPresent) {
      this.channelPopup = true;
      this.mouPopup = false;
      this.kycPopup = false;
      this.addressPopup = false;
      this.shippingPopup = false;
    }
    if (this.g.profilePopup.isKYCVerified && this.g.profilePopup.isChannelPresent && this.g.profilePopup.isDefaultAddressPresent) {
      this.activeModal.dismiss();
    }
  }

  getFileName(fileupload): string {
    var filename = fileupload.replace(/^.*[\\\/]/, "");
    return filename;
  }

  checkPanNo() {
    this.panNoerrorMessage = "";
    let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (this.panCard && !regex.test(this.panCard)) {
      this.panNoerrorMessage = "Invalid PAN Number";
    }
  }

  loadImage(event) {
    this.uploadMou = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadMou;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  loadPancard(event) {
    this.panCardPhoto = event.target.files[0];
    this.errorMessage = "";
    this.submitPancard();
  }

  submitPancard() {
    this.g.loaderDisplay = "display";
    const file = this.panCardPhoto;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imagepanCard = data['message'];
      } else {
        this.imagepanCard = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  loadAadhar(event) {
    this.aadharPhoto = event.target.files[0];
    this.errorMessage = "";
    this.submitAadhar();
  }

  submitAadhar() {
    this.g.loaderDisplay = "display";
    const file = this.aadharPhoto;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageAadhar = data['message'];
      } else {
        this.imageAadhar = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }


  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
    console.log(this.stateList);
  }


  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }


}
